import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import clsx from "clsx";
import UseMobile from "../../hooks/useIsMobile";
import { getImageUrl, RootUrl } from "../../redux/types";

const useStyles = makeStyles((theme) => ({
  root: {
    // [theme.breakpoints.down("md")]: {
    //   backgroundColor: "white",
    // },
  },
  TableCell: {
    // backgroundColor: theme.palette.primary.main,
  },
  title: {
    fontSize: "0.9rem",
    [theme.breakpoints.down("md")]: {},

    // color: "white",
  },
  srtitle: {
    fontSize: "0.9rem",

    // color: "white",
  },
  tableImg: {
    height: 100,

    objectFit: "contain",
  },
}));

const wrapStyle = {
  width: "200px",
  wordWrap: "break-word",
};

const TableData = ({ data, header, page, rowsPerPage }) => {
  const classes = useStyles();
  const isMobile = UseMobile();
  const renderCell = (cell, index) => {
    return (
      <TableRow>
        <TableCell
          key={index}
          className={clsx(classes.TableCell, classes.srno)}
        >
          <Typography className={classes.srtitle}>
            {page === 0 ? index + 1 : page * rowsPerPage + index + 1}
          </Typography>
        </TableCell>
        {header?.map((head, index) => {
          return (
            <TableCell key={index} className={classes.TableCell}>
              {cell[head.key] && head.type === "IMAGE" ? (
                <img
                  src={getImageUrl(cell[head.key])}
                  className={classes.tableImg}
                />
              ) : (
                <Typography
                  className={classes.title}
                  style={
                    isMobile === true && head.width === 2
                      ? wrapStyle
                      : undefined
                  }
                >
                  {cell[head.key] || "-"}
                </Typography>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    );
  };
  return data?.map((cell, index) => {
    return renderCell(cell, index);
  });
};
export default TableData;
